import React from "react";
import styled from "styled-components";

const StyledParagraph = styled.p`
  color: #333;
  font-size: 0.75rem;
  text-align: left;
  &:last-of-type {
    margin-bottom: 0;
  }
`;

const Text = ({ children }) => {
  return <StyledParagraph>{children}</StyledParagraph>;
};

export default Text;
